import { Routes } from "@angular/router";
import { MsalGuard } from "@azure/msal-angular";
import { ApplicationHomeRedirectComponent } from "src/app/routing/application/application-home-redirect/application-home-redirectcomponent";
import { changeCompanyGuard, accessCompanyGuard, superUserGuard, developerGuard, centralSalesSupportGuard, contractAdminGuard } from "./guards";

export const routes: Routes = [
    {
        path: "",
        component: ApplicationHomeRedirectComponent,
        canActivate: [MsalGuard],
    },
    {
        // Anonymous PDF routes - NO MsalGuard
        // Token contains all info (quoteId, versionId, companyId, lang, currency, type)
        path: "pdf",
        loadChildren: () => import("src/pdf/routing/pdf-routing.module").then(m => m.PdfRoutingModule),
    },
    {
        // Attio "Create quote in Core" button. The deal decides the company, so this sits outside the company routes.
        path: "create-from-attio",
        loadComponent: () => import("src/app/pages/quote/create/quote/create-quote-from-attio/create-quote-from-attio.component").then(m => m.CreateQuoteFromAttioComponent),
        canActivate: [MsalGuard],
    },
    {
        // Dynamically load the company routes based on the company ID, Validates the company ID format
        matcher: segments => {
            const id = segments[0]?.path;
            return /^\d{6}$/.test(id) ? { consumed: [segments[0]], posParams: { companyId: segments[0] } } : null;
        },
        canActivate: [MsalGuard, accessCompanyGuard, changeCompanyGuard],
        children: [
            {
                path: "customer",
                canActivate: [developerGuard],
                loadChildren: () => import("../customer/customer-routing.module").then(m => m.customerRoutes),
            },
            {
                path: "contact",
                canActivate: [developerGuard],
                loadChildren: () => import("../contact/contact-routing.module").then(m => m.contactRoutes),
            },
            {
                path: "quote",
                loadChildren: () => import("../quote/quote-routing.module").then(m => m.quoteRoutes),
            },
            {
                path: "sales-order",
                canActivate: [developerGuard],
                loadChildren: () => import("../sales-order/sales-order-routing.module").then(m => m.SalesOrderRoutingModule),
            },
            {
                path: "vendor",
                loadChildren: () => import("../vendor/vendor-routing.module").then(m => m.vendorRoutes),
            },
            {
                path: "super-user",
                canActivate: [superUserGuard],
                loadChildren: () => import("../super-user/super-user-routing.module").then(m => m.SuperUserRoutingModule),
            },
            {
                path: "developer",
                canActivate: [developerGuard],
                loadChildren: () => import("../developer/developer-routing.module").then(m => m.DeveloperRoutingModule),
            },
            {
                path: "central-support",
                canActivate: [centralSalesSupportGuard],
                loadChildren: () => import("../central-support/central-support-routing.module").then(m => m.CentralSupportRoutingModule),
            },
            {
                path: "home",
                loadChildren: () => import("../home/home-routing.module").then(m => m.homeRoutes),
            },
            {
                path: "catalogs",
                loadChildren: () => import("../catalogs/catalogs-routing.module").then(m => m.catalogsRoutes),
            },
            {
                path: "contract-admin",
                canActivate: [contractAdminGuard],
                loadChildren: () => import("../contract-admin/contract-admin-routing.module").then(m => m.contractAdminRoutes),
            },
            {
                path: "contract",
                loadChildren: () => import("../contract/contract-routing.module").then(m => m.contractRoutes),
            },
            {
                path: "**",
                redirectTo: "/error/404",
            },
        ],
    },
    {
        path: "error",
        canActivate: [MsalGuard],
        loadChildren: () => import("../error/error-routing.module").then(m => m.ErrorRoutingModule),
    },
    {
        path: "**",
        redirectTo: "/error/404",
    },
];
